import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stripe-payment"
export default class extends Controller {
  static values = { publishableKey: String }

  async connect() {
    const stripe = await loadStripe(this.publishableKeyValue);
    const elements = stripe.elements();
    const cardElement = elements.create('card');
    cardElement.mount('#stripe-card-element');

    cardElement.on('change', function(event) {
      document.getElementById('stripe-card-errors').textContent =
        event.error ? event.error.message : '';
    });

    const form = this.element.closest('form');
    form.addEventListener('submit', function(event) {
      const tokenField = document.getElementById('order_stripe_token');
      if (tokenField.value) return;
      event.preventDefault();
      stripe.createToken(cardElement).then(function(result) {
        if (result.error) {
          document.getElementById('stripe-card-errors').textContent = result.error.message;
        } else {
          tokenField.value = result.token.id;
          form.submit();
        }
      });
    });
  }
}
